/*
  Neroli Theme — recently-viewed.js

  Handles are kept in localStorage; the cards themselves are fetched from the
  search endpoint with section_id, so they render through the same
  product-card snippet as everywhere else. No client-side card templating to
  drift out of sync with the Liquid.

  Nothing leaves the browser except the handles in the query string.
*/

const KEY = 'neroli:recently-viewed';
const MAX_STORED = 20;

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function remember(handle) {
  if (!handle) return;
  try {
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED)));
  } catch (error) {
    // Private browsing or a full quota — recently viewed is optional.
  }
}

class RecentlyViewed extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    const current = this.dataset.currentHandle;
    const limit = Number(this.dataset.limit) || 4;

    // Exclude the product being viewed, then record it — so it appears in the
    // list next time but not on its own page.
    const handles = read().filter((h) => h && h !== current).slice(0, limit);
    remember(current);

    if (!handles.length) return;

    const grid = this.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const root = window.Shopify?.routes?.root || '/';
    const query = handles.map((h) => `handle:${h}`).join(' OR ');
    const url = `${root}search?type=product&q=${encodeURIComponent(query)}&section_id=${this.dataset.sectionId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = html.querySelector('[data-recently-viewed-grid]');
      if (!incoming || !incoming.children.length) return;

      // Search returns matches in relevance order, not the order they were
      // viewed. Reorder to match the stored list so the most recent is first.
      const cards = Array.from(incoming.children);
      handles.forEach((handle) => {
        const card = cards.find((c) => c.querySelector(`a[href*="/products/${handle}"]`));
        if (card) grid.appendChild(card);
      });

      if (grid.children.length) this.hidden = false;
    } catch (error) {
      // Leave the section hidden rather than showing an empty heading.
    }
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed);
}
